import { apiClientWithRefreshToken } from "@/api/apiClient";
import { ExpiredNotification } from "@/v2/types";

type ExpiryCategories =
    | "EXPIRED"
    | "EXPIRED_TODAY"
    | `EXPIRES_${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}_DAY`;

type ExpiryResult = Record<ExpiryCategories, ExpiredNotification[]>;

export default async function FindAllExpiredPlantIdNotifications({
    limit,
    skip,
    search,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, string>;
}): Promise<ExpiryResult> {
    const res = await apiClientWithRefreshToken({
        url: "/employees/plant-id-expired",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...filter,
        },
    });

    return res.data;
}
